import type { MessageRouter } from '../../services/MessageRouter';
import { RestartManager } from './RestartManager';
import { setRestartManagerInstance } from './restartManagerInstance';
import { serviceContainer } from '../../services/ServiceContainer';
import { RewardsService } from '../../services/rewards/RewardsService';
import { authState } from '../../api/stores/shared';

/**
 * Creates, initializes, and wires the RestartManager singleton.
 * Extracted from init.ts so coordinator initialization stays under 500 lines.
 */
export function initRestartManager(playjectorMessageRouter: MessageRouter): RestartManager {
  const manager = new RestartManager({
    ipcService: serviceContainer.ipcService,
    rewardsService: new RewardsService(),
  });
  manager.init();
  setRestartManagerInstance(manager);

  playjectorMessageRouter.register('reboot', (msg) => manager.handleReply('reboot', msg as any));
  playjectorMessageRouter.register('scheduleReboot', (msg) => manager.handleReply('scheduleReboot', msg as any));
  playjectorMessageRouter.register('cancelScheduledReboot', (msg) => manager.handleReply('cancelScheduledReboot', msg as any));

  console.log('[Coordinators] ✓ RestartManager initialized');

  if (authState.currentState.accessToken) {
    manager.checkPendingRebootReward().catch((err) => {
      console.error('[Coordinators] checkPendingRebootReward failed:', err);
    });
  } else {
    const listenerId = authState.addListener((state) => {
      if (state.accessToken) {
        authState.removeListener(listenerId);
        manager.checkPendingRebootReward().catch((err) => {
          console.error('[Coordinators] checkPendingRebootReward failed:', err);
        });
      }
    });
  }

  return manager;
}
